import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  height: 30px;
  width: ${({ width }) => (width ? width : "100")}%;

  @media (max-width: 970px) {
    width: 100%;
  }

  input:focus {
    border: 1px solid ${({ error }) => (error ? "red" : "#2775FF")};
  }

  input[type='tel']{
    border: none;
    background-color: transparent !important;
  }
`;

export const Label = styled.label`
  position: absolute !important;
  top: -9px;
  left: 12.5px;
  font-size: 13px;
  padding: 2px 5px;
  z-index: 10;
  font-weight: 500;
  background-color:  #fff;
  color: ${({ error }) => (error ? "red" : "#000")};
`;

export const WrapperInput = styled.div`
  width: 100% !important;;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  

  .iconViewPass {
    display: flex;
    margin-top: 20px;
  }

  input[type='date'] {
    color: #272727;
    font-size: 14px;
    font-weight: 500;
    font-family: "Quicksand", sans-serif !important;
  }
`;

export const Input = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: none;
  background: none;
  font-size: 14px;
  color: #272727;
  border-radius: 4px !important;
  padding: 10px !important;;
  z-index: 1;
  border: 1px solid ${({ error }) => (error ? "red" : "#b2b2b2")};
  
  &::placeholder {
    font-weight: 300;
  }
`;

export const ErrorMessage = styled.span`
  position: absolute;
  margin-top: ${({ password }) => (password ? "2px" : "31px")};

  margin-left: 5px;

  color: red;
  font-size: 8px;
  font-weight: 400;
`;

export const ErrorMessageMask = styled.span`
  position: absolute;
  margin-top: 37px;
  margin-left: 5px;

  color: red;
  font-size: 8px;
  font-weight: 400;
`;
